module.exports = __webpack_public_path__ + "img/kiseb-poster.2b77c5b2.jpg";